import React, { useState } from 'react';
import './App.css';
import Icon from './icons';
import { ThemeToggle } from './theme';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function CreditsPoolLogin({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const res = await fetch(`${API_URL}/credits-pool/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();

            if (!res.ok || data.error) {
                setError(data.error || 'Login failed');
            } else {
                localStorage.setItem('cpResellerToken', data.token);
                localStorage.setItem('cpResellerInfo', JSON.stringify(data.reseller));
                onLogin(data.reseller, data.token);
            }
        } catch (err) {
            setError('Connection error. Please try again.');
        }
        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-theme-toggle">
                    <ThemeToggle compact />
                </div>
                <div className="login-header">
                    <h1><Icon name="card" size={22} /> Credits Pool</h1>
                    <p>Reseller Portal</p>
                </div>

                {error && (
                    <div className="alert alert-error">
                        <span><Icon name="alert" size={16} /></span>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Username</label>
                        <input
                            type="text"
                            className="form-input"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your username"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary"
                        style={{ width: '100%', marginTop: '16px' }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '13px', color: '#64748b' }}>
                    <p>Credits-based licensing portal</p>
                    <p style={{ marginTop: '8px' }}>
                        <a href="/reseller" style={{ color: '#3b82f6' }}>
                            Regular Reseller? Login here →
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CreditsPoolLogin;
